// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"418":"54d56605","637":"47003f73","668":"0686858f"}[chunkId] + ".js";
};